export default __webpack_public_path__ + "static/pragicts-our-perspectives-banner-right-balance-42686f6422adfd107da3d07ace7fbb70.jpg";